module.exports = __webpack_public_path__ + "img/tea-woman.0dc67c51.png";